import * as React from "react";
import { eBranches } from "../../../../dependencies";
import { Scoreboards } from "../../../../constants";
const ServingIndicator = props => {
    const onServeTeamClass = props.showOnServeTeamClass
        ? "rj-ev-list__indicator--serving"
        : "";
    return (Scoreboards[eBranches[props.sportId]]
        ? React.createElement("span", { className: `${onServeTeamClass} rj-ev-list__indicator`, "data-uat": "span-ev-list-indicator" })
        : React.createElement(React.Fragment, null));
};
ServingIndicator.displayName = "ServingIndicator";
export default React.memo(ServingIndicator);
//# sourceMappingURL=ServingIndicator.js.map